import { render } from "./Create.vue?vue&type=template&id=0092ab84"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=0092ab84&scope=true&lang=scss"
script.render = render

export default script